import { AppEnvironment } from 'utils/env'

export const ffgClientDetails = {
  [AppEnvironment.Shared]: {
    uuid: '2245defb-94aa-4c24-9bb1-ce9c06e097f8',
    displayName: 'FINANZCHECK.de',
    street: 'Admiralitätstraße 60',
    city: 'Hamburg',
    country: 'DE',
    zipCode: '11111',
    phone: '+49 (0) 800 433 88 77',
    workingTimes: 'Mo - So von 08 - 20 Uhr',
    email: 'test@finanzcheck.de',
    company: 'FFG FINANZCHECK Finanzportale GmbH',
    logos: {
      client: 'https://cdn.finanzcheck.de/assets/finanzcheck_logo.svg',
      ekomi: 'https://cdn.finanzcheck.de/assets/ekomi_badge.svg',
      schufaNeutral: 'https://cdn.finanzcheck.de/assets/schufa_neutral.svg',
      ssl: 'https://cdn.finanzcheck.de/assets/ssl.png',
      tuev: 'https://cdn.finanzcheck.de/assets/ffg_tuv_2026.svg'
    },
    urls: {
      dac: 'https://home.finanzcheck-shared.de/mein-kontoblick/',
      dataProtection:
        'https://website.finanzcheck-shared.de/uber-uns/datenschutz/',
      ekomi: 'https://www.ekomi.de/bewertungen-finanzcheck.html',
      faq: 'https://website.finanzcheck-shared.de/faq/kontoblick/',
      faqHome: 'https://home.finanzcheck-shared.de/faq',
      home: 'https://home.finanzcheck-shared.de/',
      imprint: 'https://website.finanzcheck-shared.de/uber-uns/impressum/',
      logout: 'https://home.finanzcheck-shared.de/logout',
      mandatoryInformation:
        'https://legal-docs.finanzcheck-shared.de/mandatoryInformation.pdf',
      precontractual:
        'https://website.finanzcheck-shared.de/uber-uns/pflichtinformation/darlehensvermittlung',
      startPage: 'https://website.finanzcheck-shared.de',
      termsAndConditions: 'https://website.finanzcheck-shared.de/uber-uns/agb/',
      tuev: 'https://www.tuv-saar.com/certificates/46548'
    }
  },
  [AppEnvironment.Stage]: {
    uuid: '744e3a15-6238-4c2e-9c39-8411cf2b6a1b',
    displayName: 'FINANZCHECK.de',
    street: 'Admiralitätstraße 60',
    city: 'Hamburg',
    country: 'DE',
    zipCode: '20457',
    phone: '0800 433 88 77',
    workingTimes: 'Mo - So von 08 - 20 Uhr',
    email: 'mandant@mcc.finanzcheck.de',
    company: 'FFG FINANZCHECK Finanzportale GmbH',
    logos: {
      client: 'https://cdn.finanzcheck.de/assets/finanzcheck_logo.svg',
      ekomi: 'https://cdn.finanzcheck.de/assets/ekomi_badge.svg',
      schufaNeutral: 'https://cdn.finanzcheck.de/assets/schufa_neutral.svg',
      ssl: 'https://cdn.finanzcheck.de/assets/ssl.png',
      tuev: 'https://cdn.finanzcheck.de/assets/ffg_tuv_2026.svg'
    },
    urls: {
      dac: 'https://home.finanzcheck-stage.de/mein-kontoblick/',
      dataProtection:
        'https://website.finanzcheck-stage.de/uber-uns/datenschutz/',
      ekomi: 'https://www.ekomi.de/bewertungen-finanzcheck.html',
      faq: 'https://website.finanzcheck-stage.de/faq/kontoblick/',
      faqHome: 'https://home.finanzcheck-stage.de/faq',
      home: 'https://home.finanzcheck-stage.de/',
      imprint: 'https://website.finanzcheck-stage.de/uber-uns/impressum/',
      logout: 'https://home.finanzcheck-stage.de/logout',
      mandatoryInformation:
        'https://legal-docs.finanzcheck-stage.de/mandatoryInformation.pdf',
      precontractual:
        'https://website.finanzcheck-stage.de/uber-uns/pflichtinformation/darlehensvermittlung',
      startPage: 'https://website.finanzcheck-stage.de',
      termsAndConditions: 'https://website.finanzcheck-stage.de/uber-uns/agb/',
      tuev: 'https://www.tuv-saar.com/certificates/46548'
    }
  },
  [AppEnvironment.Production]: {
    uuid: 'de0b41bd-175b-4b13-adf8-eef7450bf698',
    displayName: 'FINANZCHECK.de',
    street: 'Admiralitätstraße 60',
    city: 'Hamburg',
    country: 'DE',
    zipCode: '20459',
    phone: '+49 (0) 800 433 88 77',
    workingTimes: 'Mo - So von 08 - 20 Uhr',
    email: 'kredite@finanzcheck.de',
    company: 'FFG FINANZCHECK Finanzportale GmbH',
    logos: {
      client: 'https://cdn.finanzcheck.de/assets/finanzcheck_logo.svg',
      ekomi: 'https://cdn.finanzcheck.de/assets/ekomi_badge.svg',
      schufaNeutral: 'https://cdn.finanzcheck.de/assets/schufa_neutral.svg',
      ssl: 'https://cdn.finanzcheck.de/assets/ssl.png',
      tuev: 'https://cdn.finanzcheck.de/assets/ffg_tuv_2026.svg'
    },
    urls: {
      dac: 'https://home.finanzcheck.de/mein-kontoblick/',
      dataProtection: 'https://www.finanzcheck.de/uber-uns/datenschutz/',
      ekomi: 'https://www.ekomi.de/bewertungen-finanzcheck.html',
      faq: 'https://www.finanzcheck.de/faq/kontoblick/',
      faqHome: 'https://home.finanzcheck.de/faq',
      home: 'https://home.finanzcheck.de/',
      imprint: 'https://www.finanzcheck.de/uber-uns/impressum/',
      logout: 'https://home.finanzcheck.de/logout',
      mandatoryInformation:
        'https://legal-docs.finanzcheck.de/mandatoryInformation.pdf',
      precontractual:
        'https://finanzcheck.de/uber-uns/pflichtinformation/darlehensvermittlung',
      startPage: 'https://www.finanzcheck.de',
      termsAndConditions: 'https://www.finanzcheck.de/uber-uns/agb/',
      tuev: 'https://www.tuv-saar.com/certificates/46548'
    }
  }
}

export const smavaClientDetails = {
  [AppEnvironment.Shared]: {
    uuid: 'f9343d8a-4bd3-48b8-a504-e99f102f463c',
    displayName: 'smava',
    street: 'Palisadenstraße 90',
    city: 'Berlin',
    country: 'DE',
    zipCode: '10243',
    phone: '0800 000 98 00',
    workingTimes: 'Mo - Fr 08 - 20 Uhr, Sa 10 - 15 Uhr',
    email: 'info@smava.de',
    company: 'smava GmbH',
    logos: {
      client: 'https://cdn.smava.de/assets/smava_logo.svg',
      ekomi: 'https://cdn.smava.de/assets/ekomi_badge.svg',
      focusMoneyBadge: 'https://cdn.smava.de/assets/focusmoney_vertical.svg',
      focusMoneyBadgeAlt:
        'https://cdn.smava.de/assets/focusmoney_alt_vertical.png',
      guenstigerGehtNicht: 'https://cdn.smava.de/assets/gunster_geht_nicht.svg',
      schufaNeutral: 'https://cdn.smava.de/assets/schufa_neutral.svg',
      ssl: 'https://cdn.smava.de/assets/ssl.png',
      tuev: 'https://cdn.smava.de/assets/smava_tuv_2026.svg'
    },
    urls: {
      dac: 'https://home.smava-shared.de/mein-kontoblick/',
      dataProtection: 'https://website.smava-shared.de/datenschutz',
      declarationOfConsentAdvertising:
        'https://website.smava-shared.de/einwilligungserklarung',
      ekomi: 'https://www.ekomi.de/bewertungen-smava-gmbh.html',
      faq: 'https://website.smava-shared.de/kredit/kontoblick/',
      faqHome: 'https://home.smava-shared.de/faq',
      focusMoney: 'https://cdn.smava.de/docs/smava_focus_money.pdf',
      home: 'https://home.smava-shared.de/',
      imprint: 'https://website.smava-shared.de/impressum',
      logout: 'https://home.smava-shared.de/logout',
      mandatoryInformation:
        'https://website.smava-shared.de/darlehensvermittlung',
      precontractual: 'https://website.smava-shared.de/darlehensvermittlung',
      startPage: 'https://website.smava-shared.de/',
      termsAndConditions: 'https://website.smava-shared.de/agb',
      tuev: 'https://www.tuv-saar.com/certificates/46547',
      ekomiApi: 'https://website.smava-shared.de/api/ekomi/component/'
    }
  },
  [AppEnvironment.Stage]: {
    uuid: 'f9343d8a-4bd3-48b8-a504-e99f102f463c',
    displayName: 'smava',
    street: 'Palisadenstraße 90',
    city: 'Berlin',
    country: 'DE',
    zipCode: '10243',
    phone: '0800 000 98 00',
    workingTimes: 'Mo - Fr 08 - 20 Uhr, Sa 10 - 15 Uhr',
    email: 'info@smava.de',
    company: 'smava GmbH',
    logos: {
      client: 'https://cdn.smava.de/assets/smava_logo.svg',
      ekomi: 'https://cdn.smava.de/assets/ekomi_badge.svg',
      focusMoneyBadge: 'https://cdn.smava.de/assets/focusmoney_vertical.svg',
      focusMoneyBadgeAlt:
        'https://cdn.smava.de/assets/focusmoney_alt_vertical.png',
      guenstigerGehtNicht: 'https://cdn.smava.de/assets/gunster_geht_nicht.svg',
      schufaNeutral: 'https://cdn.smava.de/assets/schufa_neutral.svg',
      ssl: 'https://cdn.smava.de/assets/ssl.png',
      tuev: 'https://cdn.smava.de/assets/smava_tuv_2026.svg'
    },
    urls: {
      dac: 'https://home.smava-stage.de/mein-kontoblick/',
      dataProtection: 'https://website.smava-stage.de/datenschutz',
      declarationOfConsentAdvertising:
        'https://website.smava-stage.de/einwilligungserklarung',
      ekomi: 'https://www.ekomi.de/bewertungen-smava-gmbh.html',
      faq: 'https://website.smava-stage.de/kredit/kontoblick/',
      faqHome: 'https://home.smava-stage.de/faq',
      focusMoney: 'https://cdn.smava.de/docs/smava_focus_money.pdf',
      home: 'https://home.smava-stage.de/',
      imprint: 'https://website.smava-stage.de/impressum',
      logout: 'https://home.smava-stage.de/logout',
      mandatoryInformation:
        'https://website.smava-stage.de/darlehensvermittlung',
      precontractual: 'https://website.smava-stage.de/darlehensvermittlung',
      startPage: 'https://website.smava-stage.de/',
      termsAndConditions: 'https://website.smava-stage.de/agb',
      tuev: 'https://www.tuv-saar.com/certificates/46547',
      ekomiApi: 'https://website.smava-stage.de/api/ekomi/component/'
    }
  },
  [AppEnvironment.Production]: {
    uuid: 'f9343d8a-4bd3-48b8-a504-e99f102f463c',
    displayName: 'smava',
    street: 'Palisadenstraße 90',
    city: 'Berlin',
    country: 'DE',
    zipCode: '10243',
    phone: '0800 000 98 00',
    workingTimes: 'Mo - Fr 08 - 20 Uhr, Sa 10 - 15 Uhr',
    email: 'info@smava.de',
    company: 'smava GmbH',
    logos: {
      client: 'https://cdn.smava.de/assets/smava_logo.svg',
      ekomi: 'https://cdn.smava.de/assets/ekomi_badge.svg',
      focusMoneyBadge: 'https://cdn.smava.de/assets/focusmoney_vertical.svg',
      focusMoneyBadgeAlt:
        'https://cdn.smava.de/assets/focusmoney_alt_vertical.png',
      guenstigerGehtNicht: 'https://cdn.smava.de/assets/gunster_geht_nicht.svg',
      schufaNeutral: 'https://cdn.smava.de/assets/schufa_neutral.svg',
      ssl: 'https://cdn.smava.de/assets/ssl.png',
      tuev: 'https://cdn.smava.de/assets/smava_tuv_2026.svg'
    },
    urls: {
      dac: 'https://home.smava.de/mein-kontoblick/',
      dataProtection: 'https://www.smava.de/datenschutz',
      declarationOfConsentAdvertising:
        'https://www.smava.de/einwilligungserklarung',
      ekomi: 'https://www.ekomi.de/bewertungen-smava-gmbh.html',
      faq: 'https://www.smava.de/kredit/kontoblick/',
      faqHome: 'https://home.smava.de/faq',
      focusMoney: 'https://cdn.smava.de/docs/smava_focus_money.pdf',
      home: 'https://home.smava.de/',
      imprint: 'https://www.smava.de/impressum',
      logout: 'https://home.smava.de/logout',
      mandatoryInformation: 'https://www.smava.de/darlehensvermittlung',
      precontractual: 'https://www.smava.de/darlehensvermittlung',
      startPage: 'https://www.smava.de/',
      termsAndConditions: 'https://www.smava.de/agb',
      tuev: 'https://www.tuv-saar.com/certificates/46547',
      ekomiApi: 'https://www.smava.de/api/ekomi/component/'
    }
  }
}
